import type { FC } from 'react';
import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { ModernizeBanner } from '@confluence/modernize-confluence-ipm-modal/entry-points/ModernizeBanner.tsx';
import { RovoAwarenessHomeBanner } from '@confluence/rovo-awareness/entry-points/RovoAwarenessHomeBanner.ts';

import { OnboardingTakeover } from '../../Onboarding/OnboardingTakeover.tsx';
import type { OnboardingTakeoverType } from '@confluence/experiment-home-onboarding-takeover-v2/entry-points/useOnboardingTakeoverType.ts';

const modernizeBannerContainerStyles = css({
	position: 'relative',
	gridColumn: '1 / span 1',
	// If other banners are showing, this will be the 2nd or 3rd row
	gridRow:
		'(1 + var(--home-has-onboarding-experience) + var(--home-show-rovo-awareness-banner)) / span 1',
	marginTop: '0px',

	marginBottom: token('space.300'),
});

const rovoAwarenessBannerContainerStyles = css({
	position: 'relative',
	gridColumn: '1 / span 1',
	// This banner will be at the top
	gridRow: '1 / span 1',
	marginTop: '0px',
	marginBottom: token('space.300'),
});

const homeBannerContainerStyles = css({
	gridColumn: '1 / span 1',
	gridRow: '1 / span 1',
	display: 'contents',
});

interface HomeBannerContainerProps {
	onboardingTakeoverType: OnboardingTakeoverType | null;
	isTemplatesCollectionEligible: boolean;
	isModernizeBannerEligible: boolean;
	shouldShowRovoBanner: boolean;
}

export const HomeBannerContainer: FC<HomeBannerContainerProps> = ({
	onboardingTakeoverType,
	isTemplatesCollectionEligible,
	isModernizeBannerEligible,
	shouldShowRovoBanner,
}) => {
	return (
		<div css={homeBannerContainerStyles}>
			{shouldShowRovoBanner && (
				<div css={rovoAwarenessBannerContainerStyles}>
					<RovoAwarenessHomeBanner />
				</div>
			)}
			<OnboardingTakeover
				onboardingTakeoverType={onboardingTakeoverType}
				isTemplatesCollectionEligible={isTemplatesCollectionEligible}
			/>
			{isModernizeBannerEligible && (
				<div css={modernizeBannerContainerStyles}>
					<ModernizeBanner />
				</div>
			)}
		</div>
	);
};
